module.exports = __webpack_public_path__ + "static/img/自主演进.479a595d.png";